



























import Vue from "vue";

export default Vue.extend({
  name: "OnscreenMenu",
  props: {
    btntext: String,
    btnicon: String,
    size: String,
  },
  data() {
    return {
      showOnscreenMenu: false as boolean,
      showRight: false as boolean,
      maxWidth: null as number | null,
      menuPos: "left" as string,
    };
  },
  methods: {
    toggleOnscreenMenu() {
      this.showOnscreenMenu = !this.showOnscreenMenu;
      if (!this.showOnscreenMenu) {
        this.menuPos = "left";
      }
    },

    calcPosition(e: any) {
      const windowWidth = window.innerWidth;
      const menuPosLeft = e.target.nextSibling.getBoundingClientRect().left;
      const menuWidth = e.target.nextSibling.offsetWidth;

      if (menuPosLeft > windowWidth * 0.5) {
        if (menuPosLeft - menuWidth > windowWidth || menuPosLeft - menuWidth <= 0) {
          this.menuPos = "fullwidth";
        } else {
          this.menuPos = "right";
        }
      } else {
        if (menuPosLeft + menuWidth > windowWidth) {
          this.menuPos = "fullwidth";
        } else {
          this.menuPos = "left";
        }
      }
    },
  },
});
